<div class="card" id="vehicle-gps-devices">
    <div class="card-body">
        <h3 class="card-title">Tracking Devices</h3>
        @if ((devices && (devices.length > 0))) {
            <p class="card-subtitle">{{devices[0].vehicle}} | {{devices[0].vin}}</p>
        }
        <ul class="list-group list-group-flush gps-device-list">
            @for (device of devices; track device; let i = $index) {
                <li class="list-group-item">
                    <p><a href="{{device.url}}" target="_blank">{{device.company}} {{device.product}} {{device.category}}</a></p>
                    <p class="subtitle">Placed {{device.location}} by {{device.installer}}</p>
                    <p class="subtitle">{{device.serial}}</p>
                </li>
            }
            <li class="button-bar list-group-item">
                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">Ok</button>
            </li>
        </ul>
    </div>
</div>